import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of as observableOf} from "rxjs";
import {Gateway, ProcessorConfig} from "../../_models";
import {map} from "rxjs/operators";
import {CrudService} from '../crud.service';

@Injectable()
export class CheckoutGatewayService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'gateways');
  }

  getProcessorTypes(): Observable<ProcessorConfig[]> {
    let typesString = sessionStorage.getItem('processorTypes');

    if (typesString) {
      // get the cached processor types
      return observableOf(JSON.parse(typesString));
    } else {
      // processor types not cached, so get it from the server
      return this.http.get<any>(this.route + '/processor_types/').pipe(map((types: ProcessorConfig[]) => {
        sessionStorage.setItem('processorTypes', JSON.stringify(types)); // cache the types returned from the server
        return types;
      }));
    }
  }

  verify(id: number | string): Observable<Gateway> {
    return this.http.post<Gateway>(this.route + '/' + id.toString() + '/verify/', {});
  }

  verifyThreeDsNetwork(id: number | string, network: string): Observable<Gateway> {
    return this.http.post<Gateway>(this.route + '/' + id.toString() + '/verify_3ds_network/', {network: network});
  }

  enable(id: number | string): Observable<Gateway> {
    return this.http.post<Gateway>(this.route + '/' + id.toString() + '/enable/', {});
  }

  disable(id: number | string): Observable<Gateway> {
    return this.http.post<Gateway>(this.route + '/' + id.toString() + '/disable/', {});
  }
}
